import { render, staticRenderFns } from "./ConfigNumberElement.vue?vue&type=template&id=063dab1e&scoped=true&"
import script from "./ConfigNumberElement.vue?vue&type=script&lang=js&"
export * from "./ConfigNumberElement.vue?vue&type=script&lang=js&"
import style0 from "./ConfigNumberElement.vue?vue&type=style&index=0&id=063dab1e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063dab1e",
  null
  
)

export default component.exports